import { THouseType } from "../interfaces/interfaces";
import i18n from "../i18n";
import { capitalizeFirstLetter } from "./common";

export const getHouseName = (
  houseType: THouseType,
  user: { first_name: string; last_name: string }
) => {
  if (user.first_name === "" && user.last_name === "") {
    return capitalizeFirstLetter(houseType).replaceAll("_", " ");
  }

  return `${user.first_name}'s ${i18n.t(
    `hostrooms:roomsDetails.typeRoom.items.${houseType}.title`
  )}`;
};
